import React from 'react';
import ChartContain from '../../../Componant/Widgets/Chart';

const ChartWidgets = () => {
  return (
    <div className='page-body'>
      <ChartContain />
    </div>
  );
};

export default ChartWidgets;
